import { createContext, useContext } from 'react';

export const AuthContext = createContext();

//Creating a new context to contain Login data - Soruce; https://reactjs.org/docs/context.html
export function useAuth() {
    return useContext(AuthContext);
}